import React from "react";
import styled from "styled-components";
import { ICAMNavroute } from '../../../utils/ICAMnavroute.js';
import IUMRSNavBar from "./IUMRSNavbar.jsx";
import IUMRSFooter from "./IUMRSFooter";
import { commitee } from "../../../utils/IUMRScommitee.js";
import NotificationDropdown from "../../../hooks/notificationsDropdown.jsx";

const IUMRScommitee = () => {
    return (
    <Wrapper>
        <IUMRSNavBar navroute={ICAMNavroute}/>
        <NotificationDropdown />
        <Header>
            <div className="header">
                <h2>LOCAL ORGANISING COMMITTEE</h2>
            </div> 
        </Header>

        <LocalOrganizers>
            <CommitteeGrid>
                {commitee.slice(0, 22).map((commitee) => (
                <MemberCard key={commitee.id}>
                    <div className="name">{commitee.name}</div>
                    <div className="affiliation">{commitee.affiliation}</div>
                </MemberCard>
                ))}
            </CommitteeGrid>
        </LocalOrganizers>
        <IUMRSFooter />
    </Wrapper>
    )
}

const Wrapper = styled.div`
  background-color: white;
`

const LocalOrganizers = styled.div`
  padding: 4rem 5%;
  max-width: 1400px;
  margin: 5rem auto;
`

const Header = styled.div`
  .header {
    width: 100%;
    height: 10rem;
    background-color: #082D4A;
    margin: 0;
    text-align: center;
    
    h2 {
      margin: 0;
      color: white;
      font-family: "PT Serif", serif;
      font-style: normal;
      font-weight: 600;
      letter-spacing: .005em;
      font-size: 1.5rem;
      line-height: 10rem;
    }
  }

   @media only screen and (min-width: 800px) {
        .header{
            h2{font-size: 2rem;}
        }
    }

`

const CommitteeGrid = styled.div`
  display: grid;
  grid-template-columns: 1fr;
  gap: 2.5rem;
  
  @media (min-width: 768px) {
    grid-template-columns: repeat(2, 1fr);
  }
  
  @media (min-width: 1024px) {
    grid-template-columns: repeat(3, 1fr);
  }
`;

const MemberCard = styled.div`
  background-color: white;
  border-radius: 8px;
  box-shadow: 0 3px 10px rgba(0, 0, 0, 0.08);
  padding: 2rem;
  transition: transform 0.3s ease, box-shadow 0.3s ease;
  border-left: 5px solid #082D4A;
  min-height: 7rem;
  display: flex;
  flex-direction: column;
  justify-content: center;
  
  &:hover {
    transform: translateY(-5px);
    box-shadow: 0 10px 20px rgba(0, 0, 0, 0.12);
  }

  .name {
    font-weight: 700;
    font-size: 1.1rem;
    margin-bottom: 1rem;
    color:  #CA9D3B;
    text-align: center;
    text-transform: uppercase;
    letter-spacing: 0.5px;
  }

  .affiliation {
    font-size: 1rem;
    color: #666;
    text-align: center;
  }
`;

export default IUMRScommitee;